import useAuth from '@src/core/auth/components/auth0-wrapper';
import { useUnleashContext } from '@unleash/proxy-client-react';
import { FC, useCallback, useEffect } from 'react';

const APPLICATION_NAME: string = 'SSP';
const FlagContextUpdateProvider: FC = ({ children }) => {
  const { user } = useAuth();

  const changeContext = useUnleashContext();

  const updateContext = useCallback(() => {
    changeContext({
      userId: user?.id,
      properties: {
        email: user?.email,
        app: APPLICATION_NAME,
      },
    });
  }, [changeContext, user]);

  useEffect(() => {
    updateContext();
  }, [updateContext]);

  return <>{children}</>;
};

export default FlagContextUpdateProvider;
